export default __webpack_public_path__ + "static/media/PromosTostIcon.689cf409.svg";